// extracted by mini-css-extract-plugin
export default {"main-link":"MainLink_main-link__O4hO4"};